import FolderCardContent, { Props } from './FolderCardContent';
import connect from './FolderCardContent.container';

export default connect(FolderCardContent);
export { type Props };
